import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_4d56643e from 'nuxt_plugin_head_4d56643e' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_8a68022a from 'nuxt_plugin_plugin0_8a68022a' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_8a67196c from 'nuxt_plugin_plugin1_8a67196c' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_8a6630ae from 'nuxt_plugin_plugin2_8a6630ae' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_8a6547f0 from 'nuxt_plugin_plugin3_8a6547f0' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_8a645f32 from 'nuxt_plugin_plugin4_8a645f32' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_8a637674 from 'nuxt_plugin_plugin5_8a637674' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_8a628db6 from 'nuxt_plugin_plugin6_8a628db6' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_8a61a4f8 from 'nuxt_plugin_plugin7_8a61a4f8' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_8a60bc3a from 'nuxt_plugin_plugin8_8a60bc3a' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_8a5fd37c from 'nuxt_plugin_plugin9_8a5fd37c' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_c27c0658 from 'nuxt_plugin_plugin10_c27c0658' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_c27b1d9a from 'nuxt_plugin_plugin11_c27b1d9a' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_c27a34dc from 'nuxt_plugin_plugin12_c27a34dc' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_c2794c1e from 'nuxt_plugin_plugin13_c2794c1e' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_c2786360 from 'nuxt_plugin_plugin14_c2786360' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_c2777aa2 from 'nuxt_plugin_plugin15_c2777aa2' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_c27691e4 from 'nuxt_plugin_plugin16_c27691e4' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_c275a926 from 'nuxt_plugin_plugin17_c275a926' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_c274c068 from 'nuxt_plugin_plugin18_c274c068' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_c273d7aa from 'nuxt_plugin_plugin19_c273d7aa' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_c25fd756 from 'nuxt_plugin_plugin20_c25fd756' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_c25eee98 from 'nuxt_plugin_plugin21_c25eee98' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_c25e05da from 'nuxt_plugin_plugin22_c25e05da' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_c25d1d1c from 'nuxt_plugin_plugin23_c25d1d1c' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_c25c345e from 'nuxt_plugin_plugin24_c25c345e' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_4d56643e === 'function') {
    await nuxt_plugin_head_4d56643e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_8a68022a === 'function') {
    await nuxt_plugin_plugin0_8a68022a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_8a67196c === 'function') {
    await nuxt_plugin_plugin1_8a67196c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_8a6630ae === 'function') {
    await nuxt_plugin_plugin2_8a6630ae(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_8a6547f0 === 'function') {
    await nuxt_plugin_plugin3_8a6547f0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_8a645f32 === 'function') {
    await nuxt_plugin_plugin4_8a645f32(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_8a637674 === 'function') {
    await nuxt_plugin_plugin5_8a637674(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_8a628db6 === 'function') {
    await nuxt_plugin_plugin6_8a628db6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_8a61a4f8 === 'function') {
    await nuxt_plugin_plugin7_8a61a4f8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_8a60bc3a === 'function') {
    await nuxt_plugin_plugin8_8a60bc3a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_8a5fd37c === 'function') {
    await nuxt_plugin_plugin9_8a5fd37c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_c27c0658 === 'function') {
    await nuxt_plugin_plugin10_c27c0658(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_c27b1d9a === 'function') {
    await nuxt_plugin_plugin11_c27b1d9a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_c27a34dc === 'function') {
    await nuxt_plugin_plugin12_c27a34dc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_c2794c1e === 'function') {
    await nuxt_plugin_plugin13_c2794c1e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_c2786360 === 'function') {
    await nuxt_plugin_plugin14_c2786360(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_c2777aa2 === 'function') {
    await nuxt_plugin_plugin15_c2777aa2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_c27691e4 === 'function') {
    await nuxt_plugin_plugin16_c27691e4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_c275a926 === 'function') {
    await nuxt_plugin_plugin17_c275a926(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_c274c068 === 'function') {
    await nuxt_plugin_plugin18_c274c068(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_c273d7aa === 'function') {
    await nuxt_plugin_plugin19_c273d7aa(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_c25fd756 === 'function') {
    await nuxt_plugin_plugin20_c25fd756(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_c25eee98 === 'function') {
    await nuxt_plugin_plugin21_c25eee98(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_c25e05da === 'function') {
    await nuxt_plugin_plugin22_c25e05da(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_c25d1d1c === 'function') {
    await nuxt_plugin_plugin23_c25d1d1c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_c25c345e === 'function') {
    await nuxt_plugin_plugin24_c25c345e(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
